import { parsePhoneNumberWithError, PhoneNumber } from 'libphonenumber-js';
import React from 'react';

import { EmptyFieldValueRenderer } from '@/components/molecules/EmptyFieldValueRenderer';
import { FieldValue } from '@/components/molecules/FieldValue';
import { PhoneNumberField, ValueType } from '@/types/fields';

interface Props {
  readonly value: ValueType;
  readonly field: PhoneNumberField<unknown>;
}
export const PhoneNumberFieldValueRenderer: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { value } = props;

  const parsed = React.useMemo((): PhoneNumber | null => {
    if (typeof value === 'string') {
      try {
        return parsePhoneNumberWithError(value);
      } catch {
        return null;
      }
    } else {
      return null;
    }
  }, [value]);

  const formatted = React.useMemo((): string | null => {
    if (parsed === null) {
      if (typeof value === 'string') {
        return value === '' ? null : value;
      }

      return null;
    }

    return parsed.format('INTERNATIONAL');
  }, [parsed, value]);

  if (formatted === null) {
    return <EmptyFieldValueRenderer />;
  }

  return <FieldValue value={formatted} />;
};
